import { render, staticRenderFns } from "./TitleCreditsPortrait.vue?vue&type=template&id=6a0811ca&scoped=true"
import script from "./TitleCreditsPortrait.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleCreditsPortrait.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleCreditsPortrait.vue?vue&type=style&index=0&id=6a0811ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0811ca",
  null
  
)

export default component.exports